import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';
import 'normalize.css';
import 'index.css';
import { Root } from 'views/Root';
import { ReleaseVersionDomain } from 'models/ReleaseVersion';
import 'raf/polyfill';
import 'core-js/stable';
import 'intl';
import 'intl/locale-data/jsonp/en';
import 'regenerator-runtime/runtime.js';
import { shouldPolyfill } from '@formatjs/intl-relativetimeformat/should-polyfill';

async function polyfillForIntl() {
  if (!global.Intl) {
    // iOS 9系の場合Intlがサポートされていないため、intl packageを読み込む
    // TODO: Intl.DateTimeFormat などに対応していないので対応する
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    global.Intl = require('intl');
  }

  if (shouldPolyfill()) {
    // data 取得前に polyfill の import を行う
    import('@formatjs/intl-relativetimeformat/polyfill');
  }

  const polyfilled =
    global.Intl.RelativeTimeFormat != null &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (global.Intl.RelativeTimeFormat as any).polyfilled === true;

  if (polyfilled) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    await require('@formatjs/intl-relativetimeformat/locale-data/en');
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    await require('@formatjs/intl-relativetimeformat/locale-data/ja');
  }
}

polyfillForIntl();

// 環境変数として SENTRY_DSN が設定されている場合のみ Sentry にエラーログを送信する
const sentryDsn = process.env.SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    release: ReleaseVersionDomain.currentVersion(),
    normalizeDepth: 10,
    ignoreErrors: [
      // Zalo アプリの内部ブラウザが注入するスクリプト由来のエラー
      // Safari: "Can't find variable: zaloJSV2"
      // Chrome: "zaloJSV2 is not defined"
      /zaloJSV2/,
      // ブラウザ拡張機能が閉じられたタブへ sendMessage を試みた際のエラー
      // "Invalid call to runtime.sendMessage(). Tab not found."
      /Invalid call to runtime\.sendMessage\(\)/,
    ],
  });
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <HelmetProvider>
      <Root />
    </HelmetProvider>
  );
}
